import { render } from "./Tuition.vue?vue&type=template&id=3d4dd8d2&scoped=true"
import script from "./Tuition.vue?vue&type=script&lang=js"
export * from "./Tuition.vue?vue&type=script&lang=js"

import "./Tuition.vue?vue&type=style&index=0&id=3d4dd8d2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4dd8d2"]])

export default __exports__